import { TextSearchFilter } from "./TextSearchFilter";
import { PlatformFilter } from "./PlatformFilter";
import { MinFollowersFilter } from "./MinFollowersFilter";
import { EngRateFilter } from "./EngRateFilter";
import { MultiSelectFilter } from "./MultiSelectFilter";
import { ToggleFilterDropdown } from "./ToggleFilterDropdown";
import type { ToggleFilterOption } from "./ToggleFilterDropdown";
import { useFilterStore } from "@/marketing/stores/useFilterStore";
import { REGION_OPTIONS } from "@/marketing/models/influencer";

const REGION_SELECT_OPTIONS = REGION_OPTIONS.map((r) => ({
  value: r.value,
  label: `${r.flag} ${r.label}`,
}));

export function FilterBar() {
  const countryCodes = useFilterStore((s) => s.filters.countryCodes);
  const setCountryCodes = useFilterStore((s) => s.setCountryCodes);
  const notSelected = useFilterStore((s) => s.filters.notSelected);
  const setNotSelected = useFilterStore((s) => s.setNotSelected);
  const hasEmail = useFilterStore((s) => s.filters.hasEmail);
  const setHasEmail = useFilterStore((s) => s.setHasEmail);

  const toggleOptions: ToggleFilterOption[] = [
    {
      key: "notSelected",
      label: "Not Selected",
      active: notSelected,
      onToggle: setNotSelected,
    },
    {
      key: "hasEmail",
      label: "Has Email",
      active: !!hasEmail,
      onToggle: (v) => setHasEmail(v ? true : null),
    },
  ];

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
      <TextSearchFilter />
      <PlatformFilter />
      <MinFollowersFilter />
      <EngRateFilter />
      <MultiSelectFilter
        label="Region"
        options={REGION_SELECT_OPTIONS}
        selected={countryCodes}
        onSelectionChange={setCountryCodes}
      />
      <ToggleFilterDropdown label="More Filters" options={toggleOptions} />
    </div>
  );
}
